<div class="setupDetailWrapper">
    <form [formGroup]="dataSetForm" #form="ngForm" (ngSubmit)="submitForm()">
        <div class="configureField">
            <div class="setup-section">
                <div class="form-group">
                    <label for="sourceName">Source Name:<span class="required">*</span></label>
                    <div class="control-wrapper">
                        <input type="text" id="sourceName" name="sourceName" formControlName="sourceName" placeholder=""
                            required class="form-control form-control-sm"
                            [class.is-invalid]="dataSetForm.controls['sourceName'].invalid && (dataSetForm.controls['sourceName'].dirty || dataSetForm.controls['sourceName'].touched)">
                        <div *ngIf="dataSetForm.controls['sourceName'].invalid && (dataSetForm.controls['sourceName'].dirty || dataSetForm.controls['sourceName'].touched)"
                            class="invalid-feedback">
                            <div *ngIf="dataSetForm.controls['sourceName'].errors?.['required']">
                                This field is required.
                            </div>
                            <div *ngIf="dataSetForm.controls['sourceName'].errors?.['pattern']">
                                Alphabets, underscore and hyphen are allowed.
                            </div>
                            <div *ngIf="dataSetForm.controls['sourceName'].errors?.['maxlength']">
                                Source Name must not exceed
                                {{dataSetForm.controls['sourceName'].errors?.['maxlength']?.requiredLength}} characters.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="enrollmentId">Enrollment ID: </label>
                    <div class="control-wrapper">
                        <div class="value">{{dataSetData?.customerDetails?.enrollmentId}}</div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="sourceName">Account ID: </label>
                    <div class="control-wrapper">
                        <div class="value">{{dataSetData?.customerDetails?.accountId}}</div>
                    </div>
                </div>

                <div class="form-group">
                    <label for="payloadLocation">Payload Location: </label>
                    <div class="control-wrapper">
                        <div class="value">{{dataSetData?.customerDetails?.payloadLocation}}</div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="updateFrequency">Update Frequency: </label>
                    <div class="control-wrapper">
                        <div class="value">{{dataSetData?.customerDetails?.updateFrequency}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group">
            <div class="source-dataset-grid" formArrayName="sourceDataSet">
                <h2>Data Mapping: </h2>
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Column Headers</th>
                            <th>Select Data Type</th>
                            <th>Input length of field</th>
                            <th>Include in Indexer</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let source of sourceDataSetControls; let i = index" [formGroupName]="i">
                            <td>
                                <input type="text" formControlName="columnName"
                                    class="form-control form-control-sm disabled">
                            </td>
                            <td>
                                <select class="form-control" id="dataType" formControlName="dataType"
                                [class.is-invalid]="source.get('dataType')?.invalid && source.get('dataType')?.touched">
                                    <option value="">Select Data Type</option>
                                    <option *ngFor="let obj of validDataTypes" [ngValue]="obj">{{obj}}</option>
                                </select>
                            </td>
                            <td>
                                <input type="text" formControlName="dataLength" class="form-control form-control-sm"
                                    [class.is-invalid]="source.get('dataLength')?.invalid && source.get('dataLength')?.touched">
                                <div *ngIf="source.get('dataLength')?.invalid && source.get('dataLength')?.touched"
                                    class="invalid-feedback">
                                    <div *ngIf="source.get('dataLength')?.errors?.['required']">Data length is required.</div>
                                    <div *ngIf="source.get('dataLength')?.errors?.['pattern']">Must be a number.</div>
                                    <div *ngIf="source.get('dataLength')?.errors?.['min']">Can not be zero.</div>
                                    <div *ngIf="source.get('dataLength')?.errors?.['max']">
                                        Cannot exceed {{ source.get('dataLength')?.errors?.['max']?.max }}.
                                    </div>
                                </div>
                            </td>
                            <td>
                                <input type="checkbox" formControlName="isIndexed" class="form-control form-control-sm"
                                    (change)="onIndexerChange($event, source.get('columnName'))">
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="errorBlock">
                    <div *ngIf="dataSetForm.get('sourceDataSet')?.hasError('atLeastOneIndexed') && dataSetForm.get('sourceDataSet')?.touched"
                        class="invalid-feedback d-block ">
                        Minimum one checkbox must be selected in <b>the indexer column</b>.
                    </div>
                    <div *ngIf="dataSetForm.get('sourceDataSet')?.hasError('dataTypeRequired')"
                        class="invalid-feedback d-block">
                        Data Type required in all fields is required for all columns.
                    </div>
                    <div *ngIf="dataSetForm.get('sourceDataSet')?.hasError('invalidDataLength')"
                        class="invalid-feedback d-block">
                        Data Length is required for all Datalength fields and must be a number between 1 and 255.
                    </div>
                </div>

                <button class="button submitButton mr-2" type="submit">Submit Form</button>
            </div>
        </div>
    </form>
</div>